import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, of, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { NGXLogger } from "ngx-logger";
import { Timestamp } from "firebase/firestore";
import { PraticaFlowdy2_Firestore } from "../models/praticaFirestore.model";
import { ProntofibraCacheService } from "./prontofibra-cache.service";

@Injectable({
  providedIn: "root",
})
export class UtilService {
  apiUrl: string = environment.apiUrl + "util";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    private prontofibraCache: ProntofibraCacheService,
  ) {}

  getStatiFlowdy(): Observable<any> {
    let url = this.apiUrl + "/stati-flowdy";

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  getCategorieAppuntamentoKO(): Observable<any> {
    let url = this.apiUrl + "/categorie-installazione-ko";
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      url += "-impresa";
    }

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  getCategorieSopralluogoKO(): Observable<any> {
    let url = this.apiUrl + "/categorie-sopralluogo-ko";
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      url += "-impresa";
    }

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  getTipologieVincolo(): Observable<any> {
    let url = this.apiUrl + "/categorie-vincolo";
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      url += "-impresa";
    }

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  formattaDataDaDate(data: string | Date): string {
    if (data) {
      let dateObj: Date;

      if (data instanceof Date) {
        dateObj = data;
      } else {
        // Rimuovi il suffisso [UTC] dalla stringa
        const cleanedData = data.replace(/\[.*?\]$/, "");
        dateObj = new Date(cleanedData);
      }

      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const year = dateObj.getFullYear();
      const formattedDate = `${day}/${month}/${year}`; // Formato gg/mm/aaaa
      return formattedDate;
    }
    return "";
  }

  formattaDataDaTimestampFirestore(data: Timestamp): string {
    if (data != null) {
      const date = data.toDate();
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`; // Formato gg/mm/aaaa
      return formattedDate;
    }
    return "";
  }

  formattaDataPFDaTimestampFirestore(
    pratica: PraticaFlowdy2_Firestore,
  ): string {
    if (!pratica) {
      return "";
    }

    if (!pratica.statoPF || pratica.statoPF === "IN ATTESA") {
      return "";
    }

    const cui = pratica.cui;
    if (!cui) {
      return "";
    }

    const prontofibra = this.prontofibraCache.getByCui(cui);

    if (prontofibra && prontofibra.dataComunicazioneProntofibra) {
      return this.formattaDataDaTimestampFirestore(
        prontofibra.dataComunicazioneProntofibra,
      );
    }

    return "";
  }
}
